// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import utils from '@tcp/core/src/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import styles from '../styles/EmptyWalletRewards.styles';
import internalEndpoints from '../../../internalEndpoints';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblShopNow,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';

const goToHomePage = () => {
  utils.routerPush(internalEndpoints.shopNowPage.link, internalEndpoints.shopNowPage.path);
  return null;
};

export const EmptyWalletRewards = ({ placeRewardsLabels, className }) => {
  const clickEventdata = {
    customEvents: [],
    eventName: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationName.shop_myWallet,
    pageNavigationText: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationText.shop_myWallet,
  };
  return (
    <BodyCopy className={className}>
      <Col
        colSize={{
          small: 6,
          large: 12,
          medium: 8,
        }}
      >
        <BodyCopy fontFamily="secondary" fontSize="fs14" fontWeight="regular">
          {renderLabel(
            placeRewardsLabels?.ACC_LBL_MY_REWARDS_NO_REWARDS_MSG,
            'ACC_LBL_MY_REWARDS_NO_REWARDS_MSG'
          )}
        </BodyCopy>
      </Col>
      <Col
        colSize={{
          small: 6,
          large: 2,
          medium: 3,
        }}
      >
        <ClickTracker clickData={clickEventdata}>
          <Button
            className="elem-mt-XL shopNowButton"
            buttonVariation="fixed-width"
            fill="BLUE"
            color="white"
            onClick={goToHomePage}
            data-locator="my-rewards-shop-now-btn"
          >
            {renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_GENERIC_LABELS}.${lblShopNow}`,
                GlobalGenericLabels
              ),
              'lbl_shop_now'
            )}
          </Button>
        </ClickTracker>
      </Col>
    </BodyCopy>
  );
};

EmptyWalletRewards.propTypes = {
  placeRewardsLabels: PropTypes.shape({
    // lbl_my_rewards_shop_now: PropTypes.string,
    ACC_LBL_MY_REWARDS_NO_REWARDS_MSG: PropTypes.string,
  }),
  className: PropTypes.string,
};

EmptyWalletRewards.defaultProps = {
  placeRewardsLabels: {
    // lbl_my_rewards_shop_now: '',
    ACC_LBL_MY_REWARDS_NO_REWARDS_MSG: '',
  },

  className: '',
};

export default withStyles(EmptyWalletRewards, styles);
